// extracted by mini-css-extract-plugin
export default {"list_wrapper":"List_list_wrapper__9o08F"};